import { blendWithWhite, hexColorToRgba, rgbaToHexColor, stringToColor } from "./colors";

export const getPaymentZoneColor = (zoneName: string) => {
  const lowerName = zoneName.toLowerCase();
  if (lowerName.includes("vert")) {
    return "#26BA59";
  } else if (lowerName.includes("bleu")) {
    return "#66B8E9";
  } else if (lowerName.includes("rouge")) {
    return "#DE3D3D";
  } else if (lowerName.includes("jaune")) {
    return "#F4C22B";
  } else if (lowerName.includes("orange")) {
    return "#FF7A36";
  } else {
    // Generate color
    return stringToColor(zoneName);
  }
};

export const getPaymentZoneBackgroundColor = (zoneName: string) => {
  const mainColor = getPaymentZoneColor(zoneName);
  const rgba = hexColorToRgba(mainColor).slice(0, 3) as [number, number, number];
  const blendedRgba = blendWithWhite(rgba, 0.2);

  return rgbaToHexColor(blendedRgba);
};
